import { SVGProps } from "react";

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99977 0.147705C3.66285 0.147705 0.147461 3.66335 0.147461 8.00001C0.147461 12.3367 3.66285 15.8523 7.99977 15.8523C12.3364 15.8523 15.8521 12.3367 15.8521 8.00001C15.8521 3.66335 12.3364 0.147705 7.99977 0.147705ZM12.2943 6.13471L7.17544 11.2534C7.05582 11.3733 6.86155 11.3733 6.74192 11.2534L3.70529 8.21678C3.58567 8.09716 3.58567 7.90289 3.70529 7.78315L4.65974 6.82883C4.77936 6.70908 4.97362 6.70908 5.09326 6.82883L6.9587 8.694L10.9063 4.74663C11.0259 4.62688 11.2202 4.62688 11.3399 4.74663L12.2943 5.70095C12.4142 5.8207 12.4142 6.01497 12.2943 6.13471Z"
      fill="#13CB75"
    />
  </svg>
);

export default SVGComponent;
